<template>
  <div class="p-6 bg-white/60 rounded-xl min-h-screen">
    <div class="bg-white/70 rounded-xl p-3 mb-4 shadow-sm border border-gray-100">
      <div class="flex flex-wrap items-center gap-2">
        <input v-model="filters.name_search" placeholder="نام"
               class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-32 text-right"
               @keyup.enter="applyFilters">

        <input v-model="filters.sku" placeholder="SKU"
               class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-32 text-right"
               @keyup.enter="applyFilters">

        <input v-model="filters.id_in" placeholder="شناسه"
               class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-28 text-right"
               @keyup.enter="applyFilters">

        <searchable-select
            v-model="filters.brand_in"
            :options="brands"
            placeholder="همه برندها"
            class="w-40"
            @change="applyFilters"
        />

        <select v-model="filters.currency_in"
                class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-32 text-right"
                @change="applyFilters">
          <option value="">همه ارزها</option>
          <option v-for="c in currencies" :key="c.id" :value="c.id">{{ c.name }}</option>
          <option value="null">بدون ارز</option>
        </select>

        <!-- وضعیت‌ها -->
        <select v-model="filters.status_in"
                class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-32 text-right"
                @change="applyFilters">
          <option value="">همه وضعیت‌ها</option>
          <option value="pr">نیاز به بررسی</option>
          <option value="pending">در انتظار تایید</option>
          <option value="draft">پیش‌نویس</option>
          <option value="publish">منتشر شده</option>
        </select>

        <div class="flex gap-1 ml-auto">
          <button @click="applyFilters"
                  class="px-2 py-1.5 bg-gradient-to-r from-red-500 to-blue-600 text-white rounded-md shadow-sm hover:shadow-md text-xs"
                  title="اعمال فیلتر">اعمال</button>
          <button @click="resetFilters"
                  class="px-2 py-1.5 bg-gradient-to-r from-gray-500 to-blue-600 text-white rounded-md shadow-sm hover:shadow-md text-xs"
                  title="حذف فیلترها">حذف فیلتر ها</button>


          <button @click="resetBulkSelectors"
                  :disabled="bulkLoading"
                  class="px-2 py-1.5 bg-gradient-to-r from-gray-500 to-red-600 text-white rounded-md shadow-sm hover:shadow-md text-xs"
                  title="حذف فیلترها">ریست سلکتورها</button>



        </div>
      </div>
    </div>
    <div class="bg-white/70 rounded-xl p-3 mb-3 shadow-sm border border-gray-100">
      <div class="grid grid-cols-4 gap-1">
        <category-tree-select
            label="دسته‌بندی"
            v-model="bulk.categorization"
            :categories="categorizations"
            api-url="product/categorization"
        />
        <category-tree-select
            label="خواص"
            v-model="bulk.avails"
            :categories="avails"
            api-url="product/avails"
        />
        <category-tree-select
            label="ویژگی"
            v-model="bulk.features"
            :categories="features"
            api-url="product/feature"

        />
        <category-tree-select
            label="طیف رنگی"
            v-model="bulk.color_spectrum"
            :categories="color_spectrum"
            api-url="product/colorSpectrum"

        />
      </div>
    </div>


    <div class="bg-white/70 rounded-xl shadow-sm border border-gray-100 overflow-hidden mb-10" ref="listRoot">
      <div class="overflow-x-auto">
        <table class="min-w-full text-sm">
          <thead class="bg-gray-50">
          <tr>
            <th class="p-3 w-10">
              <input type="checkbox"
                     :checked="allOnPageChecked"
                     @change="toggleAllOnPage($event.target.checked)">
            </th>
            <th class="p-3 text-right text-xs font-medium text-gray-500">تصویر</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500">نام</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500">SKU</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500">برند</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500">وضعیت</th>
          </tr>
          </thead>

          <tbody>
          <tr v-if="loading">
            <td colspan="6" class="p-4 text-center text-gray-600">در حال بارگذاری…</td>
          </tr>

          <tr v-else-if="products.length === 0">
            <td colspan="6" class="p-4 text-center text-gray-500">محصولی یافت نشد</td>
          </tr>

          <tr v-else
              v-for="p in products"
              :key="p.id"
              class="border-t border-gray-100 hover:bg-gray-50">
            <td class="p-3 w-10">
              <input type="checkbox"
                     :checked="isSelected(p.id)"
                     @change="toggleOne(p.id, $event.target.checked)">
            </td>
            <td class="p-3">
              <img v-if="p.image" :src="img_source(p.image)" class="w-10 h-10 rounded object-cover border">
            </td>
            <td class="p-3 text-[12px] font-medium text-gray-900">{{ p.name }}</td>
            <td class="p-3 text-[12px]">
              {{ Array.isArray(p.skus) && p.skus.length ? p.skus.join('، ') : (p.sixteen_digit_code || '-') }}
            </td>
            <td class="p-3 text-[12px]">{{ p.brand && p.brand.name ? p.brand.name : '-' }}</td>
            <td class="p-3">
              <span class="px-1.5 py-0.5 rounded-full text-[10px] font-medium"
                    :class="{
                      'bg-green-100 text-green-800': p.status === 'publish',
                      'bg-yellow-100 text-yellow-800': p.status === 'pending',
                      'bg-orange-100 text-orange-800': p.status === 'pr',
                      'bg-gray-100 text-gray-800': p.status === 'draft',
                      'bg-red-100 text-red-800': p.status === 'archived'
                    }">
                {{ getStatusLabel(p.status) }}
              </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination + info -->
      <div class="p-4 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4">
        <div class="flex items-center gap-2 ml-auto">
          <label class="text-xs text-gray-600">تعداد در هر صفحه:</label>
          <select v-model.number="itemsPerPage" @change="changePerPage"
                  class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-24 text-right">
            <option :value="10">10</option>
            <option :value="20">20</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
        </div>

        <div class="text-sm text-gray-600">
          نمایش {{ (currentPage - 1) * itemsPerPage + 1 }} تا
          {{ Math.min(currentPage * itemsPerPage, totalProducts) }} از
          {{ totalProducts }} محصول
        </div>

        <div class="flex gap-1">
          <button @click="prevPage" :disabled="currentPage === 1"
                  class="p-2 border border-gray-200 rounded-lg bg-white hover:bg-gray-50 disabled:opacity-50">
            بعدی↑
          </button>

          <button v-for="page in visiblePages" :key="page" @click="goToPage(page)"
                  class="p-2 text-center border border-gray-200 rounded-full"
                  :class="{
                    'bg-gradient-to-r from-blue-500/60 to-blue-600/50 text-white shadow-md': page === currentPage,
                    'bg-white hover:bg-gray-50': page !== currentPage,
                    'cursor-default': page === '...'
                  }"
                  :disabled="page === '...'">
            {{ page }}
          </button>

          <button @click="nextPage" :disabled="currentPage * itemsPerPage >= totalProducts"
                  class="p-2 border border-gray-200 rounded-lg bg-white hover:bg-gray-50 disabled:opacity-50">
            قبلی↓
          </button>
        </div>
      </div>
    </div>

    <!-- نوار اکشن چسبان (Bulk) -->
    <div v-show="selectedCount > 0"
         class="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 bg-white/95 border border-gray-200 shadow-xl rounded-2xl px-4 py-3 flex items-center gap-3">
      <div class="text-sm">
        {{ selectedCount.toLocaleString('fa-IR') }} مورد انتخاب شده
      </div>

      <button @click="applyBulk"
              :disabled="!canApply || bulkLoading"
              class="px-3 py-1.5 rounded-lg text-white text-sm bg-gradient-to-r from-blue-500 to-blue-600 disabled:opacity-60">
        <span v-if="!bulkLoading">اعمال به انتخاب‌شده‌ها</span>
        <span v-else>در حال اعمال…</span>
      </button>

      <button @click="clearSelection"
              class="px-3 py-1.5 rounded-lg text-sm border border-gray-300 bg-white hover:bg-gray-50">
        پاک‌کردن انتخاب‌ها
      </button>
    </div>
  </div>
</template>

<script>
/**
 * فرض‌ها:
 * - متدهای `this.request`, `this.endpoint`, `this.img_source`, `this.$toast` در پروژه‌ات موجودند (مثلاً از یک mixin).
 * - <searchable-select> و <category-tree-select> در مسیرهای زیر موجودند.
 * - Vue 2
 */
import SearchableSelect from "@/components/selects/SearchableSelect";
import CategoryTreeSelect from "@/modules/product_admin/CategoryTreeSelect";

export default {
  name: "AdminProductBulkCat",
  components: { SearchableSelect, CategoryTreeSelect },

  data() {
    return {
      // لیست و وضعیت‌ها
      loading: true,
      products: [],
      totalProducts: 0,
      currentPage: 1,
      itemsPerPage: 10,

      // فیلترها
      filters: {
        id_in: "",
        name_search: "",
        sku: "",
        min_price: "",
        max_price: "",
        min_inventory: "",
        max_inventory: "",
        brand_in: "",
        status_in: "",
        content_status: "",
        catalog_need: true,
        currency_in: "",
      },

      // انتخاب‌ها
      selectedIds: new Set(),
      bulkLoading: false,

      // ۳ سلکتور
      bulk: {
        categorization: [],
        avails: [],
        color_spectrum: [],
        features: [],
      },

      // دیتاهای لازم برای سلکتورها/فیلترها
      categorizations: [],
      avails: [],
      features: [],
      color_spectrum: [],
      brands: [],
      currencies: [],
    };
  },

  computed: {
    // صفحات
    visiblePages() {
      const totalPages = Math.ceil(this.totalProducts / this.itemsPerPage);
      const range = 1;
      const pages = [];
      if (totalPages <= 1) return [1];

      pages.push(1);
      if (this.currentPage - range > 2) pages.push("...");
      for (let i = Math.max(2, this.currentPage - range); i <= Math.min(totalPages - 1, this.currentPage + range); i++) {
        pages.push(i);
      }
      if (this.currentPage + range < totalPages - 1) pages.push("...");
      pages.push(totalPages);
      return pages;
    },

    // انتخاب‌ها
    selectedCount() {
      return this.selectedIds.size;
    },
    idsOnPage() {
      return this.products.map(p => p.id);
    },
    allOnPageChecked() {
      return this.idsOnPage.length > 0 && this.idsOnPage.every(id => this.selectedIds.has(id));
    },
    canApply() {
      const anyBulk =
          (this.bulk.categorization && this.bulk.categorization.length) ||
          (this.bulk.avails && this.bulk.avails.length) ||
          (this.bulk.features && this.bulk.features.length);
      return this.selectedCount > 0 && anyBulk;
    },
  },

  methods: {
    resetBulkSelectors() {
      this.bulk = { categorization: [], avails: [], features: [] };
    },
    fetchProducts() {
      this.loading = true;
      const params = {
        limit: this.itemsPerPage,
        offset: (this.currentPage - 1) * this.itemsPerPage,
        ...this.filters,
      };
      Object.keys(params).forEach(k => { if (params[k] === "") delete params[k]; });

      this.request({
        url: this.endpoint("shop/adminProducts"),
        method: "get",
        params,
        success: (data) => {
          this.products = data.results || [];
          this.totalProducts = data.count || 0;
          this.loading = false;
        },
        error: () => { this.loading = false; },
      });
    },

    fetchCategorizations() {
      this.request({
        url: this.endpoint("product/categorizationTree"),
        method: "get",
        success: (d) => { this.categorizations = d || []; },
      });
    },
    fetchColorSpectrum() {
      this.request({
        url: this.endpoint("product/colorSpectrumTree"),
        method: "get",
        success: (d) => { this.color_spectrum = d || []; },
      });
    },
    fetchAvails() {
      this.request({
        url: this.endpoint("product/availsTree"),
        method: "get",
        success: (d) => { this.avails = d || []; },
      });
    },
    fetchFeatures() {
      this.request({
        url: this.endpoint("product/featureTree"),
        method: "get",
        success: (d) => { this.features = d || []; },
      });
    },
    fetchBrands() {
      this.request({
        url: this.endpoint("api/brands"),
        method: "get",
        success: (d) => { this.brands = d || []; },
      });
    },
    fetchCurrency() {
      this.request({
        url: this.endpoint("main/currency"),
        method: "get",
        success: (d) => { this.currencies = d || []; },
      });
    },

    // ===== Filters & pagination =====
    applyFilters() {
      this.currentPage = 1;
      this.fetchProducts();
    },
    resetFilters() {
      this.filters = {
        id_in: "",
        name_search: "",
        sku: "",
        min_price: "",
        max_price: "",
        min_inventory: "",
        max_inventory: "",
        brand_in: "",
        status_in: "",
        content_status: "",
        catalog_need: "",
        currency_in: "",
      };
      this.applyFilters();
    },
    changePerPage() {
      this.currentPage = 1;
      this.fetchProducts();
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchProducts();
      }
    },
    nextPage() {
      if (this.currentPage * this.itemsPerPage < this.totalProducts) {
        this.currentPage++;
        this.fetchProducts();
      }
    },
    goToPage(page) {
      if (page === "...") return;
      this.currentPage = page;
      this.fetchProducts();
    },
    refreshProducts() {
      this.fetchProducts();
    },

    // ===== Selection =====
    isSelected(id) { return this.selectedIds.has(id); },
    toggleOne(id, checked) {
      if (checked) this.selectedIds.add(id);
      else this.selectedIds.delete(id);
      // force reactivity in Vue2 for Set:
      this.selectedIds = new Set(this.selectedIds);
    },
    toggleAllOnPage(checked) {
      if (checked) this.idsOnPage.forEach(id => this.selectedIds.add(id));
      else this.idsOnPage.forEach(id => this.selectedIds.delete(id));
      this.selectedIds = new Set(this.selectedIds);
    },
    clearSelection() {
      this.selectedIds.clear();
      this.selectedIds = new Set();
    },

    // ===== Bulk Apply =====
    idsFromNodes(nodes) {
      return (Array.isArray(nodes) ? nodes : [])
          .map(n => (n && (n.id != null ? n.id : n.value)))
          .filter(Boolean);
    },
    applyBulk() {
      if (!this.canApply) return;

      const payload = {
        product_ids: Array.from(this.selectedIds),
        categorization_ids: this.idsFromNodes(this.bulk.categorization),
        avails_ids: this.idsFromNodes(this.bulk.avails),
        colors_ids: this.idsFromNodes(this.bulk.color_spectrum),
        features_ids: this.idsFromNodes(this.bulk.features),
      };

      this.bulkLoading = true;
      this.request({
        url: this.endpoint("product/bulkcat"),
        method: "post",
        data: payload,
        success: () => {
          this.$toast && this.$toast.success("اعمال شد");
          this.clearSelection();
          this.fetchProducts();
          this.bulkLoading = false
        },
        error: () => {
          this.$toast && this.$toast.error("خطا در اعمال");
        },
        finally: () => { this.bulkLoading = false; },
      });
    },

    getStatusLabel(status) {
      const map = { draft: "پیش‌نویس", pr: "نیاز به بررسی", pending: "در انتظار تایید", publish: "منتشر شده" };
      if (!status) return " ";
      return map[status] || status;
    },
  },

  mounted() {
    this.fetchProducts();
    this.fetchBrands();
    this.fetchCurrency();
    this.fetchColorSpectrum();
    this.fetchCategorizations();
    this.fetchAvails();
    this.fetchFeatures();
  },
};
</script>

<style scoped>
body { direction: rtl; text-align: right; }
table { direction: rtl; }
</style>
